module.exports = __webpack_public_path__ + "img/hongkun-cultural-brigade.c1998200.png";